"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.event = exports.pageView = exports.usePageViews = exports.usePagesViews = exports.GoogleAnalytics = void 0;
var components_1 = require("./components");
Object.defineProperty(exports, "GoogleAnalytics", { enumerable: true, get: function () { return components_1.GoogleAnalytics; } });
var hooks_1 = require("./hooks");
Object.defineProperty(exports, "usePagesViews", { enumerable: true, get: function () { return hooks_1.usePagesViews; } });
Object.defineProperty(exports, "usePageViews", { enumerable: true, get: function () { return hooks_1.usePageViews; } });
var interactions_1 = require("./interactions");
Object.defineProperty(exports, "pageView", { enumerable: true, get: function () { return interactions_1.pageView; } });
Object.defineProperty(exports, "event", { enumerable: true, get: function () { return interactions_1.event; } });
//# sourceMappingURL=index.js.map